import { FormInfoValue } from "./forminfovalue";
import { ButtonsModel } from "../tablelist/button.model";
import { IDropdownSettings } from "ng-multiselect-dropdown/multiselect.model";

export class FormInfoField {

    public type: number;
    public label: string;
    public formControlName: string;
    public placeholder: string;
    public values: unknown;
    public selectedValue: unknown;
    public active: boolean;
    public enabled: boolean;
    public validators: unknown[];
    public infoText: string;
    public invalidText: string;
    public columns: number;
    public columnsOffset: number;
    public button: ButtonsModel;
    public callback: (item: unknown) => void;
    public acceptedExtensions: string;
    public multipleFiles: boolean;
    public dropdownSettings: IDropdownSettings;

    constructor(
        type: number,
        label: string,
        formControlName: string,
        validators: unknown[],
        placeholder: string,
        values: FormInfoValue[],
        selectedValue: unknown,
        active: boolean,
        enabled: boolean,
        infoText: string = null,
        columns: number,
        columnsOffset: number,
        button?: ButtonsModel,
        callback?: (item: unknown) => void,
        acceptedExtensions?: string,
        multipleFiles?: boolean,
        dropdownSettings?: IDropdownSettings) {
        this.type = type;
        this.label = label;
        this.formControlName = formControlName;
        this.placeholder = (placeholder) ? placeholder : "";
        this.values = values;
        this.selectedValue = selectedValue;
        this.active = active;
        this.enabled = enabled;
        this.validators = validators;
        this.infoText = infoText;
        this.columns = columns;
        this.columnsOffset = columnsOffset;
        if (button) {
            this.button = button;
        }
        this.callback = callback;
        this.acceptedExtensions = acceptedExtensions;
        this.multipleFiles = multipleFiles;
        this.dropdownSettings = dropdownSettings;
    }
}
